import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers, mergeProps as _mergeProps, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Teleport as _Teleport, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  class: "modal-title",
  ref: "modalTitle"
}
const _hoisted_2 = { class: "title-block" }
const _hoisted_3 = { class: "title" }
const _hoisted_4 = { class: "modal-content" }
const _hoisted_5 = { class: "description" }
const _hoisted_6 = { class: "actions" }
const _hoisted_7 = {
  href: "/login",
  class: "btn btn-blue"
}
const _hoisted_8 = {
  href: "/register",
  class: "btn btn-blue"
}

import { onBeforeUnmount, onMounted, ref, watch } from "vue";
  import { trans } from "@/utils/trans";

  
export default /*#__PURE__*/_defineComponent({
  __name: 'AuthPopup',
  props: {
    message: {}
  },
  setup(__props: any, { expose: __expose }) {

  const props = __props;

  const isVisible = ref(false);
  const zIndex = ref(0);

  onMounted(() => {
    document.addEventListener("keydown", closeByEscapeKey);
  });

  onBeforeUnmount(() => {
    document.removeEventListener("keydown", closeByEscapeKey);
  });

  watch(isVisible, (nv) => {
    zIndex.value = nv ? 14 : 0;
  });

  const open = () => {
    isVisible.value = true;
  };

  const close = () => {
    isVisible.value = false;
  };

  const closeByEscapeKey = (event) => {
    if (event.keyCode === 27) {
      close();
    }
  };

  __expose({
    open,
    close
  });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    (isVisible.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "modal-container",
          style: _normalizeStyle({ 'z-index': zIndex.value + 1 })
        }, [
          _createElementVNode("div", _mergeProps({ class: "modal info-popup" }, _ctx.$attrs, { ref: "modalBlock" }), [
            _createElementVNode("div", _hoisted_1, [
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(trans)("modals.auth.title")), 1)
              ]),
              _createElementVNode("div", {
                class: "modal__close",
                onClick: close
              })
            ], 512),
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, _toDisplayString(props.message), 1),
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("a", _hoisted_7, _toDisplayString(_unref(trans)("modals.auth.login_btn")), 1),
                _createElementVNode("a", _hoisted_8, _toDisplayString(_unref(trans)("modals.auth.sign_up_btn")), 1),
                _createElementVNode("a", {
                  href: "#",
                  onClick: _withModifiers(close, ["prevent"]),
                  class: "btn btn-blue-outline"
                }, _toDisplayString(_unref(trans)("modals.auth.not_now_btn")), 1)
              ])
            ])
          ], 16)
        ], 4))
      : _createCommentVNode("", true),
    (isVisible.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: "modal-overlay background-fill",
          style: _normalizeStyle({ 'z-index': zIndex.value }),
          onClick: _cache[0] || (_cache[0] = ($event: any) => (isVisible.value = false))
        }, null, 4))
      : _createCommentVNode("", true)
  ]))
}
}

})